<template>
    <div class="py-5 text-center">
        <div v-if="(!show_logo || show_logo === 'true') && from.name != 'Multiversity' && from.name != 'Dipendente'">
            <a :href="site_url">
                <img class="d-block mx-auto mb-5" :src="logo" alt="Logo" style="max-width: 200px;">
            </a>
        </div>
        <div v-else class="mb-4">
            <img src="../../assets/logo-multiversity.webp" alt="Descrizione Immagine WEBP" width="200">
        </div>
        <div>
            <h2 class="mb-1" v-if="from.name != 'Multiversity'">Iscrizione Online</h2>
            <h3 v-else class="mb-1">Configuratore Retta e Costi</h3>
        </div>
        <p class="lead mb-0">
            <span v-html="title"></span>
        </p>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            title: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                logo: 'settings/logo',
                site_url: 'settings/site_url',
                show_logo: 'settings/show_logo',
                from: 'settings/from'
            })
        }
    }
</script>
